import { IExtendableDto } from "@ryde/shared";

export enum BulkDriversMessageFormFieldsEnum {
  subject = "subject",
  message = "message",
  preview = "preview",
  isEmail = "isEmail",
  isSms = "isSms",
  isPush = "isPush",
}

export const driversMessageKeysMappedTemplates: Partial<
  Record<keyof IExtendableDto, string>
> = {
  name: "general.NAME",
};
